import { fmtPct, fmtSol, shortMint } from "../lib/data";

function Img({ entry }) {
  if (entry?.imageUrl) {
    return <img src={entry.imageUrl} alt="" loading="lazy" />;
  }
  return (
    <div className="ph" aria-hidden>
      {(entry?.symbol || "?").slice(0, 3)}
    </div>
  );
}

export function BasketMiniList({ entries = [], limit = 5 }) {
  return (
    <div className="dash-list">
      {entries.slice(0, limit).map((e) => {
        const chg = e.change24h;
        const down = chg != null && chg < 0;
        const w = Number(e.weight || 0);
        return (
          <div className="dash-row" key={e.mint || e.symbol}>
            <Img entry={e} />
            <strong>{e.symbol}</strong>
            <span className="wt">{(w * 100).toFixed(1)}%</span>
            <span className={`chg${down ? " down" : ""}`}>{fmtPct(chg)}</span>
          </div>
        );
      })}
    </div>
  );
}

export default function BasketBoard({ basket, payoutTotals }) {
  const entries = basket?.entries || [];
  if (!entries.length) {
    return <p className="loading">No active basket yet.</p>;
  }

  const entered = new Set(basket.diff?.entered || []);
  const exited = basket.diff?.exited || [];
  const byMint = payoutTotals?.byMint || {};

  return (
    <div>
      <div className="basket-list">
        {entries.map((e, i) => {
          const w = Number(e.weight || 0);
          const paid = byMint[e.mint];
          return (
            <article className="basket-row" key={e.mint || e.symbol}>
              <span className="basket-row__idx">{String(i + 1).padStart(2, "0")}</span>
              <Img entry={e} />
              <div className="basket-row__id">
                <h3>
                  {e.symbol}
                  {e.pinned ? <em> community</em> : null}
                  {!e.pinned && entered.has(e.mint) ? <em> new</em> : null}
                </h3>
                <p>
                  {e.name}
                  {e.quoteSymbol ? ` · ${e.quoteSymbol}` : ""}
                </p>
              </div>
              <div className="basket-row__weight">
                <div className="label">Weight</div>
                <strong>{(w * 100).toFixed(1)}%</strong>
                <div className="weight-bar" aria-hidden>
                  <span style={{ width: `${Math.max(6, w * 100)}%` }} />
                </div>
              </div>
              <div className="basket-row__meta">
                <div>
                  <div className="label">24h</div>
                  <strong>{fmtPct(e.change24h)}</strong>
                </div>
                <div>
                  <div className="label">Paid out</div>
                  <strong>
                    {paid?.totalSol != null ? `${fmtSol(paid.totalSol)} SOL` : "—"}
                  </strong>
                  {paid?.cycles ? (
                    <div className="basket-row__paid-note">{paid.cycles} cycles</div>
                  ) : null}
                </div>
                <a
                  href={`https://www.stonkfun.xyz/token/${e.mint}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Open →
                </a>
              </div>
            </article>
          );
        })}
      </div>
      {exited.length > 0 && (
        <p className="portfolio-footnote" style={{ marginTop: "1rem" }}>
          Exited this refresh: {exited.map((m) => shortMint(m)).join(", ")}
        </p>
      )}
      {payoutTotals?.totalSolAll != null && payoutTotals.totalSolAll > 0 && (
        <p className="portfolio-footnote" style={{ marginTop: "0.5rem" }}>
          All-time basket buys: <strong>{fmtSol(payoutTotals.totalSolAll)} SOL</strong>
          {payoutTotals.lastCycleVersion
            ? ` · through cycle v${payoutTotals.lastCycleVersion}`
            : ""}
        </p>
      )}
    </div>
  );
}
